import { spacingMixin } from '@zillow/constellation';
/* eslint-disable no-confusing-arrow */

import { css } from 'styled-components';

const getBackgroundColor = ({ type, theme }) => {
  switch (type) {
    case 'success':
      return `background-color: ${theme.ns().colors.green400};`;
    case 'error':
      return `background-color: ${theme.ns().colors.red400};`;
    case 'info':
      return 'background-color: rgba(0, 0, 0, 0.75);';
    default:
      return `background-color: ${theme.ns().colors.orange400};`;
  }
};

export default ({ theme }) =>
  theme &&
  theme.ns &&
  css`
    ${getBackgroundColor}
    color: ${theme.ns().colors.white};
    padding: 12px 46px 12px 16px;
    position: relative;
    width: 100%;
    ${spacingMixin};
  `;
